/*
 * @Description: 运营属性导入
 * @Author: 杨志航
 * @Date: 2026-03-24 09:43:27
 */
import React, { useState, useEffect, useRef } from 'react'
import api from '@/api'
import HeaderSearch from '@/components/HeaderSearch'
import { Link } from 'react-router-dom'
import { cryptoParamsIntoUrl } from '@/utils'
import Import from '@/components/Import'
import {
  Table,
  Form,
  Select,
  Spin,
  Input,
  Button,
  message,
} from 'antd'

const pageIndex = 1
const perPage = 10
let searchParam = {
  page: pageIndex,
  limit: perPage,
}
const { Option } = Select
const operationalList = [
  { id: 1, name: '直销代运营' },
  { id: 2, name: '直销自运营' },
  { id: 3, name: '渠道代运营' },
  { id: 4, name: '渠道自运营' },
  { id: 5, name: '其他' },
]

const ImportOperation = () => {
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(pageIndex)
  const [limit, setPageSize] = useState(perPage)
  const [total, setTotal] = useState(0)
  const [dataSource, setDataSource] = useState([])
  const [visibleFile, setVisibleFile] = useState(false)
  const ImportRef = useRef()
  const headerSearchRef = useRef()

  useEffect(() => {
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParam = {
      page: pageIndex,
      limit: perPage,
    }
    setPageSize(perPage)
    setPage(pageIndex)
  }

  const getList = values => {
    if (values) {
      const { page, limit } = searchParam
      searchParam = { page, limit, ...values }
    }
    let params = { ...searchParam }
    setLoading(true)
    api.getImportOperationalAttrList(params).then(data => {
      setPage(searchParam.page)
      setPageSize(searchParam.limit)
      setTotal(data.count)
      setDataSource(data.list)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const onChangeTable = (pagination, filters, sorter) => {
    searchParam.page = pagination.current
    searchParam.limit = pagination.pageSize
    getList()
  }

  const cols = [
    {
      title: '合同编号',
      dataIndex: 'contractno',
      align: 'center',
      render: (text, record) => (
        <Link to={cryptoParamsIntoUrl('/protocol/contract/details', { id: text, contractNo: text })}>{text}</Link>
      )
    },
    {
      title: '厂商ID',
      dataIndex: 'vendor',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '变更前运营属性',
      dataIndex: 'oldAttributes',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '变更后运营属性',
      dataIndex: 'attributes',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '导入人',
      dataIndex: 'creator',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '导入时间',
      dataIndex: 'createTime',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '导入文件',
      dataIndex: 'fileName',
      align: 'center',
      render: (text, record) => <a href={record.filePath}>{text}</a>
    }
  ]

  const searchItems = [
    {
      label: '合同编号',
      name: 'contractno',
      component: <Input placeholder='请输入合同编号' />,
    }, {
      label: '厂商ID',
      name: 'vendor',
      component: <Input placeholder='请输入厂商ID' />,
    }, {
      label: '导入人',
      name: 'creator',
      component: <Input placeholder='请输入导入人' />,
    }, {
      label: '变更后运营属性',
      name: 'attributes',
      component: (
        <Select 
          placeholder='请选择变更后运营属性'
          allowClear
        >
          {operationalList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)}
        </Select>
      ),
    }
  ]

  const onImportFile = () => {
    setVisibleFile(true)
    ImportRef.current.onRemoved()
  }

  const onSearch = fileList => {
    if (fileList.length > 0) {
      if (fileList[0].status !== "removed") {
        const { name, full, url } = fileList[0]
        api.importOperationalAttr({
          name,
          full,
          relative: url
        }).then(data => {
          message.success('导入成功，请到导入列表查看。')
          ImportRef.current.onLoading()
          setVisibleFile(false)
          headerSearchRef.current.resetFields()
          resetParams()
          getList()
        }).catch(data => {
          ImportRef.current.onLoading()
        })
      } else {
        message.error('请导入模板')
      }
    } else {
      message.error('请导入模板')
    }
  }

  return (
    <div className='vrdevice-stock-container'>
      <Spin spinning={loading} tip='Loading...'>
        <HeaderSearch
          search={searchItems}
          getList={getList}
          resetParams={resetParams}
          hasShowAll={false}
          ref={headerSearchRef}
        ></HeaderSearch>
        <div className='line'></div>
        <div className='vrdevice-stock-btn'>
          <Button type="primary" onClick={onImportFile}>运营属性导入</Button>
        </div>
        <Table
          size='small'
          columns={cols}
          rowKey='id'
          dataSource={dataSource}
          scroll={{ x: 'max-content' }}
          pagination={{
            defaultCurrent: pageIndex,
            pageSize: limit,
            total: total,
            showSizeChanger: true,
            showQuickJumper: true,
            current: page,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
        ></Table>
      </Spin>
      <Import
        title="运营属性导入"
        onSearch={onSearch}
        visibleFile={visibleFile}
        onCloseImport={() => setVisibleFile(false)}
        ImportTemplate="/api/File/DownTemplate?url=/templates/消耗运营属性.xlsx&name=消耗运营属性"
        ImportRef={ImportRef}
      />
    </div>
  )
}

export default Form.create()(ImportOperation)
